import { useTranslation } from "react-i18next";

export const WelsysFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="welsys-legal" role="contentinfo">
      © 2026 Welsys HMS — developed by Strutgem Technologies, operated by{" "}
      <a
        href="https://seerie.co.ke/"
        target="_blank"
        rel="noreferrer"
        className="underline hover:text-secondary-400"
      >
        Seerie Africa
      </a>
    </footer>
  );
};
